import { forwardRef, type Ref, type SVGProps } from "react";
const IconWaterFilledSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path
      fill="currentColor"
      d="M10.65 23.903s2.603 2.314 2.603 3.66S12.088 30 10.65 30c-1.437 0-2.602-1.09-2.602-2.437s2.602-3.66 2.602-3.66"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M23.071 2a1.58 1.58 0 0 1 1.572 1.578v1.578a1.58 1.58 0 0 1-1.572 1.578h-2.357v1.578h.393c.934 0 1.738.66 1.925 1.577h2.004A1.97 1.97 0 0 1 27 11.862v3.945a1.97 1.97 0 0 1-1.964 1.972h-9.822v.143a2.365 2.365 0 0 1 1.537 2.629 2.36 2.36 0 0 1-2.322 1.963H7.356a2.36 2.36 0 0 1-2.322-1.963 2.365 2.365 0 0 1 1.537-2.63v-2.509c.004-3.049 2.464-5.52 5.5-5.523h1.61a1.966 1.966 0 0 1 1.926-1.577H16V6.734h-2.357a1.58 1.58 0 0 1-1.572-1.578V3.578A1.58 1.58 0 0 1 13.643 2zM7.356 19.357a.79.79 0 0 0-.698.389.79.79 0 0 0 0 .802.79.79 0 0 0 .593.383l7.178.004a.787.787 0 0 0 .763-.788.79.79 0 0 0-.763-.79zm6.287-14.201h9.428V3.578h-9.428z"
      clipRule="evenodd"
    />
  </svg>
);
const ForwardRef = forwardRef(IconWaterFilledSVG);
ForwardRef.displayName = "IconWaterFilled";
export { ForwardRef as IconWaterFilled };
